import React from 'react'

export default function HeadernderLine({currentTab , target , isDropDown=false}) {
    return (
        <div
            className="underline"
            style={{
                opacity: currentTab === target ? 1 : 0,
                visibility: currentTab === target ? "visible" : "hidden",
                marginTop: isDropDown && 7,
                marginBottom: isDropDown && -7,
                width: isDropDown && '75%'
            }}
        ></div>
    )
}
